<template>
	<div>
		<div class="new-message">{{ currentBubble }}</div>
	</div>
</template>

<script>
import store, { getCurrentChat } from '../store'
import { post } from '../helpers/api'
import { initPusher } from '@/helpers/pusher'

export default {
	data() {
		return {
			store,
			id: null,
			currentBubble: null,
			pusher: {
				channelName: null,
				channelCode: null,
				channel: null,
			},
		}
	},

	mounted() {
		this.id = this.$route.params.id

		// We're logged in now, so load pusher
		initPusher()

		this.$pusher?.connection?.bind('connected', this.initPusherUser)
	},

	methods: {
		postFromIframe(msg) {
			console.log('Post from iframe: ' + JSON.stringify(msg))
			window.parent.postMessage(msg, '*')
		},

		messageAddedHandler(data) {
			this.postFromIframe({ type: 'newMessage' })
			console.log(data)
		},

		initPusherUser() {
			console.log('Attempting to initialize...')
			var userChannelName = 'private-user.' + this.store.auth.user.id
			var userChannel = this.$pusher.subscribe(userChannelName)

			userChannel.bind('App\\Events\\MessageAdded', this.messageAddedHandler)

			console.table(userChannel)

			userChannel.bind('pusher:subscription_error', (status) => {
				setTimeout(this.initPusherUser, 5000)
			})
		},

		connectPusher(connectedCallback) {
			this.pusher.channelCode = getCurrentChat().channelcode
			this.pusher.channelName =
				'private-bubble.' + this.id + '.' + this.pusher.channelCode
			this.pusher.channel = this.$pusher.subscribe(this.pusher.channelName)

			if (!this.pusher.channel.subscribed) {
				this.pusher.channel.bind(
					'pusher:subscription_succeeded',
					connectedCallback
				)

				this.pusher.channel.bind('pusher:subscription_error', function (
					status
				) {
					if (status != 200) {
						window.setTimeout(() => {
							chat.pusher.channel.subscribe()
						}, 1000)
					}
				})

				this.pusher.channel.bind(
					'App\\Events\\MessageAdded',
					this.messageAddedHandler
				)
			}
		},

		setCurrentBubble() {
			post('/api/v1/bubble.history', { bubble_id: this.id })
				.then(({ data }) => {
					this.currentBubble = data
					this.postFromIframe({ type: 'newMessage' })
				})
				.catch((error) => {
					if (error.response == undefined) {
						return
					}

					switch (error.response.data.error) {
						case 'BUBBLE_NOTFOUND':
							break
						default:
							console.error(
								'Unhandled error in LatestMessage.vue:setCurrentBubble - ' +
									error.response.data.error
							)
							break
					}
				})
		},
	},
}
</script>
